import { Link } from '@tanstack/react-router'
import { ArrowRight, Building2, Mail, Search } from 'lucide-react'
import { BrandLogo } from '../components/BrandLogo'

export function RegisterPage() {
  // Site is invite-only - show informational page
  return (
    <div className="auth-page min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <Link to="/" className="flex items-center gap-2">
            <BrandLogo size="lg" />
          </Link>
        </div>

        {/* Looking to book a room? */}
        <div className="border-b border-border py-8 text-center">
          <div className="w-12 h-12 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Search className="w-6 h-6 text-gray-900" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Looking to book a room?
          </h2>
          <p className="text-gray-600 mb-6">
            You don't need to sign up here. Rooms are booked through our marketplace,
            where you can browse local spaces and send a booking request.
          </p>
          <Link
            to="/marketplace"
            className="inline-flex items-center justify-center rounded-lg bg-primary-600 px-5 py-3 text-sm font-medium text-white hover:bg-primary-700 transition-colors"
          >
            Find a room
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

        {/* Venue owners: invite-only preview */}
        <div className="py-4 text-center">
          <div className="w-12 h-12 bg-community-soft rounded-full flex items-center justify-center mx-auto mb-4">
            <Building2 className="w-6 h-6 text-community-strong" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">List your rooms</h1>
          <p className="text-gray-600 mb-6">
            This sign up is for organisations that hire out their rooms, such as
            village halls, churches and community centres. Roomsi is currently in
            private preview, so venue accounts are created by invitation. If you've
            received an invitation email, please click the link in that email to
            create your account.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-3 text-left">
              <Mail className="w-5 h-5 text-gray-400 shrink-0" />
              <div className="text-sm text-gray-600">
                Check your email for an invitation link from <strong className="break-all">admin@roomsi.net</strong>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-600 mb-4">
            No invitation yet? If you'd like to list your venue on Roomsi,
            we'd love to hear from you.
          </p>
          <a
            href="mailto:admin@roomsi.net?subject=Roomsi%20Private%20Preview%20Interest"
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Mail className="w-4 h-4 mr-2" />
            Contact us
          </a>

          <p className="text-sm text-gray-500 mt-6">
            Already have an account?{' '}
            <Link to="/login" search={{ returnTo: undefined }} className="text-primary-600 hover:text-primary-700 font-medium">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
